import React, { useEffect, useAuth, useRef, useState } from "react";
import { ClientTrans } from '../services/client';
import toast from 'react-hot-toast';
import { downloadTransaction } from "../services/transactionService";
import ProfileNav from "../components/ProfileNav";
import Pagination from "../components/Pagination";
import TransactionIdModal from "./TransactionIdModal";
// import TransactionPagination from "../components/TransactionPagination";
// import Toggle from "../components/Toggle";
// import LoadingScreen from "../components/LoadingScreen";
// import TransactionPagination from "../components/TransactionPagination";
// import TransactionModal from "./Transactions/TransactionModal";
// import { downloadTransaction } from "../services/transaction";

const ClientTransaction = () => {
 const [transactions, setTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [totalTransactions, setTotalTransactions] = useState();
  const [transactModal, setTransactModal] = useState(false);
  const [transactInfo, setTransactInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isFocused, setIsFocused] = useState(false);
  const [isEndDateFocused, setIsEndDateFocused] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const itemsPerPage = 10;
  const [totalCount, setTotalCount] = useState();
  


//   const { globalProfile } = useAuth();

  const hasFetched = useRef(false);

  const filtersRef = useRef({ startDate, endDate, orderId, status });

  // Keep filtersRef updated when values change
  useEffect(() => {
    filtersRef.current = { startDate, endDate, orderId, status };
  }, [startDate, endDate, orderId, status]);

  // Custom debounce function
  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  // const fetchTransactions = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const res = await getTransactions({
  //       startDate,
  //       endDate,
  //       orderId,
  //       status,
  //     });
  //     setTransactions(res.data);
  //     setLoading(false);
  //   } catch (error) {
  //     if (error.response) {
  //       toast.error(error.response.data.message);
  //       setLoading(false);
  //     }
  //   }
  // }, [startDate, endDate, status, orderId]);

  // useEffect(() => {
  //   fetchTransactions();
  // }, [globalProfile]);

  useEffect(() => {
    // if (hasFetched.current) return; // Prevents re-fetching
    // hasFetched.current = true;

    const fetchTransactions = async () => {
      setIsPageLoading(true);
      try {
        const res = await ClientTrans(currentPage, pageSize, itemsPerPage, {
          startDate: filtersRef.current.startDate,
          endDate: filtersRef.current.endDate,
          orderId: filtersRef.current.orderId,
          status: filtersRef.current.status,
        });
        setTransactions(res.data.transactions);
        // setTotalTransactions(res.data.count);
        setTotalCount(res.data?.totalCount);
        // setLoading(false);
      } catch (error) {
        if (error.response) {
          toast.error(error.response.data.message);
          // setIsPageLoading(true);
          // setLoading(false);
        }
      } finally {
        setIsPageLoading(false); // Clear table loading state
        setLoading(false); // Clear full loading state
      }
    };
    setLoading(true);
    fetchTransactions();
  }, [currentPage, pageSize]);

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentData = transactions.slice(indexOfFirstItem, indexOfLastItem);
  // const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSearchChange = debounce((e) => {
    setOrderId(e.target.value);
    if (e.target.value === "") {
      setOrderId(null);
    }
  }, 1000);

  const resetFilter = async () => {
    try {
      const res = await ClientTrans(currentPage, pageSize, itemsPerPage);
      setTransactions(res.data.transactions);
      setFilterLoading(false);
      //setTotalTransactions(res.data.count);
      setTotalCount(res.data.totalCount);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
        setFilterLoading(false);
      }
    }
  };

  const handleProfile = (info) => {
    setTransactModal(true);
    setTransactInfo(info);
  };

  // const handleDownload = async () => {
  //   try {
  //     const blobData = await downloadTransaction({
  //       startDate,
  //       endDate,
  //       orderId,
  //       status,
  //     });

  //     // Get the content type from the response headers
  //     const contentType = blobData.type;
  //     // Create a blob from the response data
  //     const blob = new Blob([blobData], { type: contentType });
  //     // Create a URL for the blob
  //     const url = window.URL.createObjectURL(blob);
  //     // Create a temporary <a> element
  //     const link = document.createElement("a");
  //     link.href = url;
  //     // Set the filename
  //     link.download = "Transaction Report";
  //     // Simulate a click on the link to initiate the download
  //     link.click();
  //     // Cleanup
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     if (error.response) {
  //       toast.error(error.response.data.message);
  //     }
  //   }
  // };


//   if (loading && !isPageLoading) {
//     return <LoadingScreen title="Transactions" />;
//   }


  // const filter = async () => {
  //   setFilterLoading(true);
  //   try {
  //     const res = await ClientTrans(currentPage, pageSize, {
  //       startDate,
  //       endDate,
  //       orderId,
  //       status,
  //     });
  //     setTransactions(res.data.result);
  //     setFilterLoading(false);
  //     setTotalTransactions(res.data.count);
  //   } catch (error) {
  //     if (error.response) {
  //       toast.error(error.response.data.message);
  //       setFilterLoading(false);
  //     }
  //   }
  // };

   // Change page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // In your render:

  return (
    <div className="">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-navy-blue text-2xl font-bold">
          Client Transactions
        </h1>
        <div>
          <ProfileNav />
        </div>
      </div>
      <div className="xl:flex items-center justify-between mt-10">
        {/* <div className="xl:flex items-center gap-3">
          <div className="relative mt-5 sm:m-0">
            <input
              type="text"
              placeholder="Search OrderID"
              onChange={handleSearchChange}
              className="xl:w-[300px] w-full h-[40px] rounded-[10px] px-2 border border-gray-300 focus:outline-none"
            />
            <span>
              <svg
                className="absolute right-8 top-3"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.5">
                  <path
                    d="M7.22235 13.4445C10.6589 13.4445 13.4447 10.6587 13.4447 7.22223C13.4447 3.78579 10.6589 1 7.22235 1C3.78584 1 1 3.78579 1 7.22223C1 10.6587 3.78584 13.4445 7.22235 13.4445Z"
                    stroke="#030229"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.0001 15.0005L11.6167 11.6172"
                    stroke="#030229"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </svg>
            </span>
          </div>

          <div className="relative mr-4 xl:mr-0 mt-2 xl:mt-0">
            <input
              type="text"
              placeholder="Start date"
              id="start-date"
              className="focus:outline-none w-full xl:w-[130px] h-[40px] px-3 rounded-[5px]"
              onChange={(e) => setStartDate(e.target.value)}
              onFocus={(e) => {
                e.target.type = "date";
                setIsFocused(true);
              }}
              onBlur={(e) => {
                e.target.type = "text";
                setIsFocused(false);
              }}
            />
            {!isFocused && (
              <span>
                <svg
                  className="absolute right-4 top-[18px]"
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.5"
                    d="M0.5 1L4.5 5L8.5 1"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            )}
          </div>

          <div className="relative mt-2 xl:mt-0">
            <input
              type="text"
              placeholder="End date"
              id="end-date"
              className="focus:outline-none w-full xl:w-[130px] h-[40px] px-3 rounded-[5px]"
              onChange={(e) => setEndDate(e.target.value)}
              onFocus={(e) => {
                e.target.type = "date";
                setIsEndDateFocused(true);
              }}
              onBlur={(e) => {
                e.target.type = "text";
                setIsEndDateFocused(false);
              }}
            />
            {!isEndDateFocused && (
              <span>
                <svg
                  className="absolute right-4 top-[18px]"
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.5"
                    d="M0.5 1L4.5 5L8.5 1"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            )}
          </div>
          <button
            className="text-white bg-text-orange hover:bg-text-orange/90 w-[130px] lg:w-[165px] h-[42px] rounded-[10px] mb-3 md:mb-0"
            
          >
            Filter
          </button>
        </div> */}
        {/* <div className="relative">
          {!loading && (
            <>
              <button
                
                className="text-white bg-text-orange w-[130px] lg:w-[165px] h-[42px] rounded-[10px] mb-3 md:mb-0"
              >
                Export
              </button>
              <span>
                <svg
                  className="absolute left-6 lg:left-10 top-[18px]"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_4169_8547)">
                    <path
                      d="M6.91254 3.75H6.25004V1.66667C6.25004 1.4375 6.06254 1.25 5.83337 1.25H4.16671C3.93754 1.25 3.75004 1.4375 3.75004 1.66667V3.75H3.08754C2.71671 3.75 2.52921 4.2 2.79171 4.4625L4.70421 6.375C4.86671 6.5375 5.12921 6.5375 5.29171 6.375L7.20421 4.4625C7.46671 4.2 7.28337 3.75 6.91254 3.75ZM2.08337 7.91667C2.08337 8.14583 2.27087 8.33333 2.50004 8.33333H7.50004C7.72921 8.33333 7.91671 8.14583 7.91671 7.91667C7.91671 7.6875 7.72921 7.5 7.50004 7.5H2.50004C2.27087 7.5 2.08337 7.6875 2.08337 7.91667Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4169_8547">
                      <rect width="10" height="10" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </>
          )}
        </div> */}
      </div>

      {/* <section className="flex text-md justify-start sm:justify-end sm:text-xl font-bold pt-4 mb-4 pr-4">
        <span className="ml-2">
          <BusinessName />
        </span>
      </section> */}

      <div className="bg-white rounded-md mr-5 md:mr-0 sm:mt-4 sm:ml-3 sm:px-7 sm:py-5">
        <div className="flex items-center sm:justify-between">
          <div className="flex items-center">
            <p className="border-r pr-4 text-sm font-bold text-black-shade">
              Transactions
            </p>

            <div className="flex sm:flex-row items-center border-r px-4">
              <div className="flex items-center gap-1 mr-2">
                <div className="rounded-full bg-green-400 w-[6px] h-[6px]"></div>
                <p
                  className="text-[12px] font-normal text-black-shade cursor-pointer"
                  onClick={() => setStatus("APPROVED")}
                >
                  Approved
                </p>
              </div>
              <div className="flex items-center gap-1 mr-2">
                <div className="rounded-full bg-red-400 w-[6px] h-[6px]"></div>
                <p
                  className="text-[12px] font-normal text-black-shade cursor-pointer"
                  onClick={() => setStatus("Declined")}
                >
                  Declined
                </p>
              </div>
              {/* <div className="flex items-center gap-1">
                <div className="rounded-full bg-black-shade w-[6px] h-[6px]"></div>
                <p
                  className="text-[12px] font-normal text-black-shade cursor-pointer"
                  onClick={() => setStatus("Initiated")}
                >
                  Initiated
                </p>
              </div> */}
            </div>

            <div className="flex   items-center border-r px-2 gap-2">
              <div className="flex items-center gap-1">
                <button
                  className="text-black bg-white border] text-[12px] pl-3"
                  onClick={resetFilter}
                >
                  All
                </button>
              </div>
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_27_8380)">
                  <path
                    d="M3 4.06372L5.5 6.06372L8 4.06372"
                    stroke="#1C1C1C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_27_8380">
                    <rect
                      width="8.25"
                      height="12"
                      fill="white"
                      transform="translate(12 0.563721) rotate(90)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className="flex items-center justify-center mb-5">
            <Pagination
              totalItems={totalCount}
              itemsPerPage={itemsPerPage}
              paginate={paginate}
              currentPage={currentPage}
           />
          <span>
            <div className="relative ml-3 sm:ml-0">
              <span>
                <svg
                  className="absolute left-5 top-[18px]"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_22_2583)">
                    <path
                      d="M6.91242 3.75H6.24992V1.66667C6.24992 1.4375 6.06242 1.25 5.83325 1.25H4.16659C3.93742 1.25 3.74992 1.4375 3.74992 1.66667V3.75H3.08742C2.71659 3.75 2.52909 4.2 2.79159 4.4625L4.70409 6.375C4.86659 6.5375 5.12909 6.5375 5.29159 6.375L7.20409 4.4625C7.46659 4.2 7.28325 3.75 6.91242 3.75ZM2.08325 7.91667C2.08325 8.14583 2.27075 8.33333 2.49992 8.33333H7.49992C7.72909 8.33333 7.91659 8.14583 7.91659 7.91667C7.91659 7.6875 7.72909 7.5 7.49992 7.5H2.49992C2.27075 7.5 2.08325 7.6875 2.08325 7.91667Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_22_2583">
                      <rect width="10" height="10" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </span>
          </div>
        </div>
        <div className="overflow-x-auto max-w-80 sm:max-w-full">
          <table className="w-full mt-4">
            <thead className="border-b">
              <tr>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p>ID</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Exp Month</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Exp Year</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Approval Code</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Status</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Status Description</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Amount </p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Initiated Date</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
                <th>
                  <div className="flex items-center pb-3 gap-3">
                    <p className="text-[12px] font-normal">Completed Date</p>
                    <span>
                      <svg
                        width="11"
                        height="5"
                        viewBox="0 0 11 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M4.31198 4.81539C4.26398 4.78714 4.05873 4.68047 3.88989 4.5811C2.82803 3.99854 1.09 2.47881 0.559484 1.68339C0.474238 1.56259 0.293813 1.25718 0.282227 1.09401C0.282227 0.937652 0.341816 0.788602 0.462651 0.646371C0.631489 0.46907 0.89716 0.326839 1.21083 0.248904C1.4285 0.198734 2.07985 0.120799 2.09144 0.120799C2.80403 0.0428641 3.96189 0 5.24142 0C6.46052 0 7.57121 0.0428641 8.29456 0.106673C8.30615 0.11398 9.11558 0.191914 9.39284 0.277155C9.89935 0.433512 10.2139 0.738919 10.2139 1.06576V1.09401C10.2014 1.30687 9.88693 1.75451 9.87535 1.75451C9.344 2.50706 7.69122 3.99172 6.59295 4.58841C6.59295 4.58841 6.31072 4.75645 6.13444 4.82952C5.88118 4.9435 5.56751 5 5.25383 5C4.90374 5 4.57765 4.93619 4.31198 4.81539Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
{Array.isArray(transactions) && (
            <tbody>
              {transactions.length === 0 && (startDate || endDate) && (
                <tr className="text-center">
                  <td>No transactions found</td>
                </tr>
              )}
              {filterLoading || isPageLoading ? (
                <tr className="text-center">
                  <td colSpan={9}>Loading...</td>
                </tr>
              ) : (
                transactions.map((info, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } cursor-pointer text-sm hover:bg-black-shade/5`}
                    onClick={() => handleProfile(info)}
                  >
                    <td>
                      <div className="py-4">{info.id}</div>
                    </td>
                    <td>
                      <div className="py-4">{info.expMonth}</div>
                    </td>
                    <td>
                      <div className="py-4">{info.expYear}</div>
                    </td>
                    <td>
                      <div className="py-4">{info.approvalCode}</div>
                    </td>
                    <td>
                      <div className="py-4">{info.status}</div>
                    </td>
                    <td>
                      <div className="py-4">{info.statusDescription}</div>
                    </td>
                    
                    <td>{info.amount.toFixed(2)}</td>
                    <td>
                      {new Date(info.initiated).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </td>
                    <td>
                      {new Date(info.completed).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </td>
                  </tr>
                ))
              )}
            </tbody>)}
          </table>
        </div>
        {/* <div>
          <TransactionPagination
            currentPage={currentPage}
            itemsPerPage={pageSize}
            paginate={handlePageChange}
            totalItems={totalTransactions}
            isLoading={isPageLoading}
          />
        </div> */}
      </div>
      {transactModal && (
        <TransactionIdModal
          setIsModalOpen={setTransactModal}
          transactData={transactInfo}
        />
      )}
    </div>
  );
};

export default ClientTransaction